<template>
    <!-- BEGIN: Left Aside -->
    <div id="m_aside_left" class="m-grid__item m-aside-left m-aside-left--skin-dark ">
        <!-- BEGIN: Aside Menu -->
        <div id="m_ver_menu" class="m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark m-scroller ps ps--active-y" m-menu-vertical="1" m-menu-scrollable="0" m-menu-dropdown-timeout="500">
            <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
                <li class="m-menu__item  m-menu__item" v-bind:class="{'m-menu__item--active' : (activeMenu == '/admin')}" aria-haspopup="true">
                    <router-link to="/admin" class="m-menu__link ">
                        <i class="m-menu__link-icon flaticon-line-graph"></i>
                        <span class="m-menu__link-title">
                                        <span class="m-menu__link-wrap">
                                            <span class="m-menu__link-text">
                                                {{$t('Dashboard')}}
                                            </span>
                                        </span>
                                    </span>
                    </router-link>
                </li>
                <template v-for="(item, index) in menu">
                    <li class="m-menu__section " v-bind:key="`menu_section` + index">
                        <h4 class="m-menu__section-text">
                            {{$t(item.name)}}
                        </h4>
                        <i class="m-menu__section-icon flaticon-more-v3"></i>
                    </li>
                    <template v-for="subitem in item.items">
                        <template v-if="subitem.children.length > 0">
                            <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover" v-bind:key="subitem.id">
                                <a href="javascript:;" class="m-menu__link m-menu__toggle">
                                    <i class="m-menu__link-icon flaticon-layers"></i>
                                    <span class="m-menu__link-text">
                                                {{$t(subitem.title)}}
                                            </span>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                </a>
                                <div class="m-menu__submenu ">
                                    <span class="m-menu__arrow"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item  m-menu__item--parent" aria-haspopup="true">
                                                    <span class="m-menu__link">
                                                        <span class="m-menu__link-text">
                                                            {{$t(subitem.title)}}
                                                        </span>
                                                    </span>
                                        </li>
                                        <li class="m-menu__item " aria-haspopup="true" v-for="item3 in subitem.children" v-bind:key="subitem.id+item3.id">
                                            <router-link :to="item3.link" class="m-menu__link ">
                                                <i class="m-menu__link-bullet m-menu__link-bullet--dot">
                                                    <span></span>
                                                </i>
                                                <span class="m-menu__link-text">
                                                            {{$t(item3.title)}}
                                                        </span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                        <template v-else>
                            <li class="m-menu__item  m-menu__item" v-bind:class="{'m-menu__item--active' : getRoute(subitem.link)}" aria-haspopup="true" v-bind:key="subitem.id">
                                <router-link :to="subitem.link" class="m-menu__link ">
                                    <i :class="'m-menu__link-icon ' + subitem.icon"></i>
                                    <span class="m-menu__link-title">
                                            <span class="m-menu__link-wrap">
                                                <span class="m-menu__link-text">
                                                    {{$t(subitem.title)}}
                                                </span>
                                            </span>
                                        </span>
                                </router-link>
                            </li>
                        </template>
                    </template>
                </template>
            </ul>
        </div>
        <!-- END: Aside Menu -->
    </div>
    <!-- END: Left Aside -->
</template>

<script>
export default {
  name: 'NavBar',
  props: ['activeMenu', 'menu'],
  data () {
    return {
      apiUrl: ''
    }
  },
  mounted: function () {
    setTimeout(function () {
      /* window.$('#m_ver_menu').customScrollbar({
        skin: 'default-skin',
        hScroll: false
      })
      window.$('#m_aside_left_offcanvas_toggle').on('click', function () {
        window.$('#m_ver_menu .viewport').css('height', window.$('#m_ver_menu .viewport .m-menu__nav').css('height'))
      }) */
      window.mLayout.init()
      window.mQuickSidebar.init()
      window.$('.m-menu__nav li a').on('click', function () {
        window.$('#m_aside_left_close_btn').trigger('click')
      })
    }, 1000)
  },
  methods: {
    getRoute (link) {
      return (!link.indexOf((this.activeMenu + '/')) && this.activeMenu !== '/admin')
    }
  },
  created: function () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/NavBar.vue